// extracted by mini-css-extract-plugin
export default {"row":"styles_row__FP3oq","row_separated":"styles_row_separated__xvDaU","row__title":"styles_row__title__n8cQ6","row__value":"styles_row__value__O3Ink"};